/* eslint-disable no-unused-expressions */

export const limitarInput = (element, tamanho) => {
  let maximo = tamanho;
  if (element.value.length > maximo) {
    element.value = element.value.substr(0, maximo);
  }
};

export const validarEmail = (email) => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};

export const CopiarTexto = async (mensagem, tempo, textoCopiar) => {
  navigator.clipboard.writeText(textoCopiar).then(
    async () => {
      const toast = await document.createElement("ion-toast");
      toast.color = "success";
      toast.mode = "ios";
      toast.icon = "checkmark-outline";
      toast.message = mensagem;
      toast.duration = tempo;
      toast.buttons = [
        {
          text: "Ok",
          role: "cancel",
          handler: () => {
            console.log("Alerta fechado");
          },
        },
      ];

      document.body.appendChild(toast);
      await toast.present();
    },
    async () => {
      const toast = await document.createElement("ion-toast");
      toast.color = "danger";
      toast.icon = "alert-outline";
      toast.message =
        "Não foi possível copiar o texto do elemento selecionado!";
      toast.duration = tempo;
      toast.buttons = [
        {
          text: "Ok",
          role: "cancel",
          handler: () => {
            console.log("Alerta fechado");
          },
        },
      ];

      document.body.appendChild(toast);
      await toast.present();
    }
  );
};
